const ApiStore = require("stores/abstract/ApiStore");
const env = require("services/env");
const router = require("services/router");

const store = new ApiStore(
	env.get("stores.balance.collection", []),
	env.get("stores.balance.constraints", {}),
	env.get("stores.balance.metadata", {}),
	{endpoint: router.route("api.balance.index")}
);

// Hook to collection change to always keep the models sorted chronological
store.collectionChange.pipe(collection => collection.sort((a, b) => {
	return moment.unix(a.created).isAfter(moment.unix(b.created)) ? -1 : 1;
}));

module.exports = store;



// WEBPACK FOOTER //
// ./resources/js/stores/BalanceEntriesStore.js